import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { OnboardingDocument, OnboardingTab } from 'app/profile/models/onboarding.model';
import { SupplierTaskTableCol, SupplierTaskTableMasterData } from 'app/profile/models/suppliertasks.model';
import { OnboardingDocumentsService } from 'app/profile/services/onboarding-document.service';
import { I18nService } from 'app/shared/services/i18n.service';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-exist-select',
  templateUrl: './exist-select.component.html',
  styleUrls: ['./exist-select.component.scss']
})
export class ExistSelectComponent implements OnInit {
  
  @Input() columns: SupplierTaskTableCol[];
  @Input() masterData: SupplierTaskTableMasterData;
  @Input() requestType: any;
  @Output("onSelect") onSelectEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Output("onView") onViewEmitter: EventEmitter<{index: number}> = new EventEmitter<{index: number}>();
  @Output("onEdit") onEditEmitter: EventEmitter<{index: number, isFirstTime: boolean}> = new EventEmitter<{index: number, isFirstTime: boolean}>();
  @Output("onDelete") onDeleteEmitter: EventEmitter<{index: number}> = new EventEmitter<{index: number}>();
  @Output("onAdd") onAddEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output("onPrimarySelect") onPrimarySelectEmitter: EventEmitter<number> = new EventEmitter<number>();
  @Output("onFileUpload") onFileUploadEmitter: EventEmitter<any> = new EventEmitter<any>();
  displayedColumns: string[] = ['edit', 'action'];
  dataSource = new MatTableDataSource<any>([]);
  minDate: Date = new Date();
  OnboardingTab = OnboardingTab;
  
  constructor(
    public translate: I18nService,
    private onboardingDocumentsService: OnboardingDocumentsService,
  ) { }

  ngOnInit(): void {
    this.displayedColumns = [...this.columns?.map(x => x.propertyName), ...this.displayedColumns];
    let tmpList = this.masterData?.data?.map(x => ({
      isSelected: null,
      ...x
    })) || null;
    // if(!this.masterData?.disableCreateNew) tmpList.push({isSelected: !!this.masterData.isNewSelected, isNew: true})
    this.dataSource.data = tmpList;
  }

  onSelectSwitch(event, index, forceValue?: boolean){
    if([true, false].includes(forceValue)) {
      this.dataSource.data = this.dataSource?.data.map((x, i) => {
        if(i == index) x.isSelected = forceValue;
        return x;
      })
    }
    if(!this.masterData?.disableCreateNew && !this.masterData?.enableAddNew) {
      let tmpI = this.dataSource?.data?.findIndex(x => x.isSelected != false);
      if(tmpI == -1) {
        this.onSelectEmitter.emit(this.dataSource.data.length);
        return;
      }
    }
    if(this.masterData?.enableMultiSelect) {
      if(this.dataSource.data[index]?.isSelected) {
        if(!this.masterData?.disableEdit) {
          if(this.masterData?.enableFirstEdit) this.onEditEmitter.emit({index: index, isFirstTime: true});
          else this.onViewEmitter.emit({index: index});
        }
        this.onSelectEmitter.emit(index);
      } else {
        // negative to remove, and + 1 to solve -0 will be 0 
        this.onSelectEmitter.emit(-index - 1);
        if(this.dataSource.data[index]?.isPrimary) {
          this.dataSource.data[index].isPrimary = false;
          this.onPrimarySelectEmitter.emit(null);
        }
      }
    } else {
      if(this.dataSource.data[index]?.isSelected) {
        this.dataSource.data = this.dataSource.data.map((x, i) => {
          if(i != index)x.isSelected = false;
          return x
        })
        if(!this.masterData?.disableEdit) this.onEditEmitter.emit({index: index, isFirstTime: true});
        this.onSelectEmitter.emit(index);
      } else this.onSelectEmitter.emit(null);
    }
  }

  onPrimarySelected(event, index) {
    if(event?.checked) {
      this.dataSource.data = this.dataSource.data.map((x, i) => {
        if(i != index)x.isPrimary = false;
        return x
      })
      this.onPrimarySelectEmitter.emit(index);
    }
    else this.onPrimarySelectEmitter.emit(null);
  }

  onEdit(index) {
    this.onEditEmitter.emit({index: index, isFirstTime: false});
  }

  onView(index) {
    this.onViewEmitter.emit({index: index});
  }

  onDelete(index) {
    this.onDeleteEmitter.emit({index: index});
  }

  updateTableData(data, overrideToFalse: boolean) {
    if(overrideToFalse) {
      let tmpList = data?.map(x => ({
        isSelected: false,
        ...x
      })) || null;
      this.dataSource.data = tmpList;
    } else {
      let tmpList = data?.map(x => ({
        ...x
      })) || null;
      this.dataSource.data = tmpList;
    }
    
  }

  uploadFile(event, document, index, documentIndex) {
    if(document && event?.target?.files?.length) {
      document.File = event.target.files[0];
      document.FileName = event.target.files[0].name;
      this.onFileUploadEmitter.emit({index: index, documentIndex: documentIndex, file: document});
    }
  }

  downloadFile(file: OnboardingDocument) {
    if (file?.DocumentID && file?.DocumentVersion) {
      this.onboardingDocumentsService.downloadDocument(file.DocumentID, this.masterData.supplierCode, file.DocumentVersion).subscribe(resultBlob => {
        FileSaver.saveAs(resultBlob, file.FileName || file.DocumentID);
      });
    } else if (file?.File) {
      FileSaver.saveAs(file.File, file.FileName || file.File.name);
    }
  }

  onDeleteFile(document, index, documentIndex) {
    document.File = null;
    document.FileName = null;
    document.DocumentID = null;
    document.DocumentVersion = null;
    this.onFileUploadEmitter.emit({index: index, documentIndex: documentIndex, file: document});
  }

  onEffectiveDateChange(event, document, index, documentIndex) {
    this.onFileUploadEmitter.emit({index: index, documentIndex: documentIndex, file: document});
  }

  onAddItem() {
    this.onAddEmitter.emit();
  }
}